import { Button } from "@/components/ui/button";
import { cx } from "@/utils/classes.utils";
import { ChevronRight } from "lucide-react";
import type { MenuCtx, ResponsiveMenuItem } from "./types.ts";

export function MobileItem<T extends string>({
  item,
  ctx,
}: {
  item: ResponsiveMenuItem<T>;
  ctx: MenuCtx;
}) {
  switch (item.type) {
    case "label":
      return <div className="py-2">{item.content}</div>;

    case "separator":
      return <div className="my-2 h-px bg-border" />;

    case "action":
      return (
        <Button
          type="button"
          variant="ghost"
          className={cx(
            "w-full justify-start gap-2",
            item.destructive && "text-destructive hover:text-destructive",
          )}
          disabled={item.disabled}
          onClick={() => void item.onSelect(ctx)}
        >
          {item.icon}
          {item.label}
        </Button>
      );

    case "page":
      return (
        <Button
          type="button"
          variant="ghost"
          className="w-full justify-between"
          disabled={item.disabled}
          onClick={() => ctx.goTo(item.pageId)}
        >
          <span className="inline-flex items-center gap-2">
            {item.icon}
            {item.label}
          </span>
          <ChevronRight className="size-4 opacity-60" />
        </Button>
      );

    case "radio-group":
      return (
        <div className="py-2">
          {item.label ? (
            <div className="pb-2 text-sm font-medium">{item.label}</div>
          ) : null}
          <div className="space-y-1">
            {item.options.map((opt) => {
              const selected = opt.value === item.value;
              return (
                <Button
                  key={opt.value}
                  type="button"
                  variant={selected ? "secondary" : "ghost"}
                  className="w-full justify-start"
                  onClick={() => void item.onValueChange(opt.value, ctx)}
                >
                  {opt.label}
                </Button>
              );
            })}
          </div>
        </div>
      );

    default:
      return null;
  }
}
